import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@fiverr-private/fit';
import { BADGES } from '../../utils';
import I18nProviderWrapper from '../I18nProvider';
import './index.scss';

const Badge = ({ type, i18n }) => {
    if (type === BADGES.NEW) {
        return (
            <Tag className="categories-badge" theme={Tag.THEMES.HOLLOW} color={Tag.COLORS.PINK}>
                {i18n.t('categories_menu.badges.new')}
            </Tag>
        );
    }

    if (type === BADGES.BETA) {
        return (
            <Tag className="categories-badge" theme={Tag.THEMES.HOLLOW} color={Tag.COLORS.BLUE}>
                {i18n.t('categories_menu.badges.beta')}
            </Tag>
        );
    }

    return null;
};

Badge.propTypes = {
    type: PropTypes.string,
    i18n: PropTypes.object,
};

export default I18nProviderWrapper(Badge);
export { Badge };
